import { CronosListsPage } from './../cronos-lists/cronos-lists';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-cronos-filter',
  templateUrl: 'cronos-filter.html',
})
export class CronosFilterPage {

  public statusList: Array<{id: number, descricao: string, color: string, checked: boolean}>;
  private previousPage: CronosListsPage;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public viewCtrl: ViewController
  ) {
  }

  ionViewDidLoad() {
    if (this.navParams.data) {
      this.previousPage = this.navParams.data.page;
    }
    this.statusList = [
      { id: 0, descricao: 'Não Iniciado', color: 'disabled', checked: false },
      { id: 1, descricao: 'Em Andamento', color: 'primary', checked: false },
      { id: 2, descricao: 'Concluído', color: 'secondary', checked: false },
      { id: 3, descricao: 'Expirado', color: 'danger', checked: false }
    ];
    if (this.previousPage.filteredStatus != null) {
      this.previousPage.filteredStatus.forEach(x => {
        let status = this.statusList.find(y => y.id == x);
        if (status != null) {
          status.checked = true;
        }
      });
    }
  }

  applyFilter() {
    this.previousPage.filteredStatus = this.statusList.filter(x => x.checked == true).map(x => x.id);
    if (this.previousPage.filteredStatus.length == 0) {
      this.previousPage.filteredStatus = null;
    }
    this.previousPage.filter();
    this.viewCtrl.dismiss();
  }

  cancelFilter() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/cronos-filter/cronos-filter.ts